export default __webpack_public_path__ + "static/clp-dfadc8c8b64cf7f686246bab16ffb8aa.jpg";